export default __webpack_public_path__ + "f8b3d37c746840f8a6b2b2328fe52cf1.png";